import type { PersistedGameState } from '../core/domain/types';
import { createPlots } from '../features/farm/domain/farmRules';
import { createQuestState } from '../features/quest/domain/questRules';
import { quests } from './config';

export function createInitialState(nowUtc = Date.now()): PersistedGameState {
  return {
    schemaVersion: 2,
    createdAtUtc: nowUtc,
    lastSavedAtUtc: nowUtc,
    player: {
      playerId: crypto.randomUUID(),
      level: 1,
      xp: 0,
      coins: 120,
      warehouseCapacity: 50,
    },
    inventory: { seed_crop_radish: 10 },
    farm: { plots: createPlots(), lastSeenUtc: nowUtc },
    home: {
      houseLevel: 1,
      ownedFurniture: {
        furniture_oak_bed: 1,
        furniture_oak_chair: 2,
        furniture_oak_plant: 1,
      },
      placements: [],
      draftPlacements: null,
    },
    wardrobe: {
      ownedClothingIds: [
        'clothing_top_cream',
        'clothing_bottom_cocoa',
        'clothing_shoes_cocoa',
        'clothing_hat_cream',
        'clothing_dress_rose',
      ],
      equipped: {
        top: 'clothing_top_cream',
        bottom: 'clothing_bottom_cocoa',
        shoes: 'clothing_shoes_cocoa',
      },
      preview: null,
      savedOutfits: [],
    },
    quests: createQuestState(nowUtc, quests),
    collection: {
      discoveredCropIds: [],
      discoveredFurnitureIds: ['furniture_oak_bed', 'furniture_oak_chair', 'furniture_oak_plant'],
      discoveredClothingIds: [
        'clothing_top_cream',
        'clothing_bottom_cocoa',
        'clothing_shoes_cocoa',
        'clothing_hat_cream',
        'clothing_dress_rose',
      ],
      seenIds: [],
      claimedCategoryRewardIds: [],
    },
    tutorial: { step: 0, completed: false },
  };
}
